
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#EAEDF2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20 20c3.281 0 6-2.672 6-6 0-3.281-2.719-6-6-6-3.328 0-6 2.719-6 6 0 3.328 2.672 6 6 6zm2.614 1.808c.507-.163.96-.308 1.558-.308 3.469 0 6.328 2.86 6.328 6.328v1.922A2.25 2.25 0 0128.25 32h-16.5a2.221 2.221 0 01-2.25-2.25v-1.922c0-3.469 2.813-6.328 6.281-6.328.595 0 1.046.143 1.553.305.653.208 1.4.445 2.666.445 1.234 0 1.968-.235 2.614-.442zM28.25 30.5c.375 0 .75-.328.75-.75v-1.922A4.821 4.821 0 0024.172 23c-.34 0-.686.11-1.115.244-.695.219-1.607.506-3.057.506-1.47 0-2.373-.284-3.068-.502-.436-.137-.79-.248-1.15-.248C13.108 23 11 25.156 11 27.828v1.922c0 .422.328.75.75.75h16.5zM24.5 14c0-2.438-2.063-4.5-4.5-4.5-2.484 0-4.5 2.063-4.5 4.5 0 2.484 2.016 4.5 4.5 4.5 2.438 0 4.5-2.016 4.5-4.5z","fill":"#586E8C"}})])
          )
        }
      }
    